import { render, staticRenderFns } from "./RegisterVerifyEmail.vue?vue&type=template&id=50a4850f&"
import script from "./RegisterVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./RegisterVerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./RegisterVerifyEmail.vue?vue&type=style&index=0&id=50a4850f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports